import {
  APPLY_OVERRIDE,
  CLEAR_OVERRIDE,
  SET_USER_CONVERSATION_MENU,
} from './types';

export const actions = {
  applyOverride({ commit }, { source, partial }) {
    commit(APPLY_OVERRIDE, { source, partial });
  },
  clearOverride({ commit }, { source }) {
    commit(CLEAR_OVERRIDE, { source });
  },
  setUserConversationMenu({ commit }, value) {
    commit(SET_USER_CONVERSATION_MENU, value);
  },
};
